module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.pl@2x-04946ec1af3954bfc6f181ae459f276b.png";